import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { product } from '../models/interfaces';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {
  order: any = 'desc';
  category: string = null;
  limit: number = 15;
  mayor: boolean;
  primero = true;

  constructor(private database: AngularFirestore) {}

  createDoc(data: any, path: string, id: any) {
    const collection = this.database.collection(path);
    return collection.doc(id).set(data);
  }

  getCollection<product>(path: string) {
    const collection = this.database.collection<product>(path);
    return collection.valueChanges();
  }

  getColection3d(path: string) {
    const collection = this.database.collection<any>(path);
    return collection.valueChanges();
  }

  getCollectionQuery<product>(path: string, parametro: string, condicion: any, busqueda, startAt) {
    if (!startAt) startAt = new Date();
    const collection = this.database.collection<product>(path, ref =>
      ref.where(parametro, condicion, busqueda)
        .orderBy('fecha', 'desc').limit(5).startAfter(startAt)
    );
    return collection.valueChanges();
  }

  getCollectionAll(path: string, parametro: string, condicion: any, busqueda, startAt) {
    if (!startAt) startAt = new Date();
    const collection = this.database.collectionGroup<any>(path, ref =>
      ref.where(parametro, condicion, busqueda)
        .orderBy('fecha', 'desc').limit(2).startAfter(startAt)
    );
    return collection.valueChanges();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // NOTA: Firestore no permite dos 'array-contains' en la misma query.
  // Solución: filtramos por 'gender' con array-contains (campo principal de ruta)
  // y filtramos 'style' en el cliente después de recibir los datos.
  //
  // parametro  = 'gender'   → array-contains → busqueda  = 'hombre' | 'mujer' | etc.
  // parametro2 = 'style'    → filtro en cliente
  // ─────────────────────────────────────────────────────────────────────────────
  getCollectionProductos(
    path: string,
    parametro: string,      // 'gender'
    condicion: any,         // '==' (ya no se usa, mantenemos firma)
    busqueda: string,       // 'hombre' | 'mujer' | ...
    parametro2: string,     // 'style'
    busqueda2: string,      // 'casual' | '3d' | ... (puede ser null/undefined)
    orderbylist: string,
    startAt: any
  ) {
    if (!startAt) {
      switch (orderbylist) {
        case 'date':
          startAt = new Date();
          this.primero = false;
          break;
        case 'price':
          startAt = '0';
          break;
      }
    }

    let collection: any;

    switch (this.primero) {
      case true:
        if (this.category !== 'todo') {
          if (this.mayor) {
            collection = this.database.collection<any>(path, ref =>
              ref.where(parametro, 'array-contains', busqueda)
                .where('category', '==', this.category)
                .orderBy(orderbylist, this.order)
                .limit(this.limit)
                .startAfter(startAt)
            );
          } else {
            collection = this.database.collection<any>(path, ref =>
              ref.where(parametro, 'array-contains', busqueda)
                .where('category', '==', this.category)
                .orderBy(orderbylist, 'asc')
                .limit(this.limit)
                .endAt(startAt)
            );
          }
        }
        this.primero = false;

        if (this.category === 'todo') {
          if (this.mayor) {
            collection = this.database.collection<any>(path, ref =>
              ref.where(parametro, 'array-contains', busqueda)
                .orderBy(orderbylist, this.order)
                .limit(this.limit)
                .startAfter(startAt)
            );
          } else {
            collection = this.database.collection<any>(path, ref =>
              ref.where(parametro, 'array-contains', busqueda)
                .orderBy(orderbylist, 'asc')
                .limit(this.limit)
                .endAt(startAt)
            );
          }
        }
        break;

      case false:
        if (this.category !== 'todo') {
          collection = this.database.collection<any>(path, ref =>
            ref.where(parametro, 'array-contains', busqueda)
              .where('category', '==', this.category)
              .orderBy(orderbylist, this.order)
              .limit(this.limit)
              .startAfter(startAt)
          );
        }
        if (this.category === 'todo') {
          collection = this.database.collection<any>(path, ref =>
            ref.where(parametro, 'array-contains', busqueda)
              .orderBy(orderbylist, this.order)
              .limit(this.limit)
              .startAfter(startAt)
          );
        }
        break;
    }

    this.mayor = false;

    // Filtro de style en el cliente (evita el doble array-contains de Firestore)
    return collection.valueChanges().pipe(
      map((productos: any[]) => {
        if (busqueda2 && busqueda2 !== 'todo') {
          return productos.filter(p =>
            Array.isArray(p.style)
              ? p.style.includes(busqueda2)
              : p.style === busqueda2
          );
        }
        return productos;
      })
    );
  }

  getPromociones(
    path: string,
    parametro: string,   // 'gender'
    condicion: any,
    busqueda: string,    // 'hombre' | 'mujer' | ...
    orderbylist: string,
    startAt: any
  ) {
    if (!startAt) {
      switch (orderbylist) {
        case 'date':
          startAt = new Date();
          this.primero = false;
          break;
        case 'price':
          startAt = '0';
          break;
      }
    }

    let collection: any;

    if (this.primero) {
      if (this.mayor) {
        collection = this.database.collection<any>(path, ref =>
          ref.where(parametro, 'array-contains', busqueda)
            .where('offer', '==', true)
            .orderBy(orderbylist, this.order)
            .limit(this.limit)
            .startAfter(startAt)
        );
      } else {
        collection = this.database.collection<any>(path, ref =>
          ref.where(parametro, 'array-contains', busqueda)
            .where('offer', '==', true)
            .orderBy(orderbylist, 'asc')
            .limit(this.limit)
            .endAt(startAt)
        );
      }
      this.primero = false;
    } else {
      collection = this.database.collection<any>(path, ref =>
        ref.where(parametro, 'array-contains', busqueda)
          .where('offer', '==', true)
          .orderBy(orderbylist, this.order)
          .limit(this.limit)
          .startAfter(startAt)
      );
    }

    this.mayor = false;
    return collection.valueChanges();
  }

  getTodo(path: string, parametro: string, condicion: any, busqueda, orderbylist, startAt) {
    if (!startAt) {
      switch (orderbylist) {
        case 'date':
          startAt = new Date();
          this.primero = false;
          break;
        case 'price':
          startAt = '0';
          break;
      }
    }
    let collection: any;
    if (this.primero) {
      collection = this.database.collection<any>(path, ref =>
        ref.where(parametro, condicion, busqueda)
          .where('offer', condicion, true)
          .orderBy(orderbylist, 'asc')
          .limit(this.limit)
          .endAt(startAt)
      );
      this.primero = false;
    } else {
      collection = this.database.collection<any>(path, ref =>
        ref.where(parametro, condicion, busqueda)
          .where('offer', condicion, true)
          .orderBy(orderbylist, this.order)
          .limit(this.limit)
          .startAfter(startAt)
      );
    }
    return collection.valueChanges();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Search: gender ahora es array, usamos array-contains
  // ─────────────────────────────────────────────────────────────────────────────
  search(nombre: string, gender: string) {
    const collection = this.database.collection<any>('productos', ref =>
      ref.where('gender', 'array-contains', gender)
        .where('name', '>=', nombre)
        .where('name', '<=', nombre + '\uf8ff')
    );
    return collection.valueChanges();
  }

  getCollectionPage(path: string, limit: number, startAt: any) {
    if (!startAt) startAt = new Date();
    const collection = this.database.collection<any>(path, ref =>
      ref.orderBy('fecha', 'desc').limit(limit).startAfter(startAt)
    );
    return collection.valueChanges();
  }

  getDoc(path: string, id: string) {
    return this.database.collection(path).doc(id).valueChanges();
  }

  deleteDoc(path: string, id: string) {
    return this.database.collection(path).doc(id).delete();
  }

  updateDoc(data: any, path: string, id: string) {
    return this.database.collection(path).doc(id).update(data);
  }

  createId() {
    return this.database.createId();
  }
}
